import _objectSpread from"/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";/**
 * Resolves one level's paint into a plain SVG attribute bag, so the shape
 * primitives (LevelRect / LevelCircle) stay purely geometric: the shape is
 * filled with its slot color (filled variant) or stroked in its slot color
 * (outline variant). `slotAttrs` arrives already in the right channel — a fill
 * bag for the filled variant, a stroke bag for the outline variant.
 *
 * The "framed" arrangement's border is a SINGLE enclosing rounded rectangle
 * (wide around the bars, a narrow capsule around the dots), drawn by
 * LevelsStackBase in the first color — not a per-level attribute.
 */export function levelPaint(filled,slotAttrs){return filled?_objectSpread({},slotAttrs):_objectSpread({fill:"none"},slotAttrs);}